import React from "react";

const Home = () => {
  return (
    <>
      <div
        style={{ height: "80vh" }}
        className="d-flex justify-content-center align-items-center"
      >
        <h1>Hello World</h1>
      </div>
    </>
  );
};

export default Home;
